import {Button} from '@esgi/ui';
import {styled} from '@esgi/ui/theme';

export const BaseOrderButton = styled(Button.Icon, {
	width: 16,
	height: 16,
});
